var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1856,
    height: 277,
    viewBox: "0 0 1856 277",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1856,
    height: 277,
    rx: 24,
    fill: "#065EEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4253_21416)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4253_21416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1772.11 266.347C1907.76 266.347 2017.66 366.079 2017.66 489.184C2017.66 612.289 1907.76 712.022 1772.11 712.022V266.347Z",
    fill: "#4E92FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180.26 -0.185852C1315.9 -0.185852 1425.8 99.5467 1425.8 222.652C1425.8 345.757 1315.9 445.489 1180.26 445.489V-0.185852Z",
    fill: "#4E92FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123.45 179.081C1055.63 179.081 1000.6 229.02 1000.6 290.572C1000.6 352.125 1055.63 402.063 1123.45 402.063V179.226V179.081Z",
    fill: "#76AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.067 445.489C397.067 322.384 506.962 222.652 642.611 222.652C778.26 222.652 888.155 322.384 888.155 445.489L397.067 445.489Z",
    fill: "#4E92FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1131.78 -0.336578C1131.78 122.768 1021.89 222.501 886.237 222.501C750.588 222.501 640.693 122.768 640.693 -0.336578L1131.78 -0.336578Z",
    fill: "#4E92FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2718 445.489C-85.3772 445.489 -195.272 345.757 -195.272 222.652C-195.272 99.5467 -85.3772 -0.185852 50.2718 -0.185852L50.2718 445.489Z",
    fill: "#4E92FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1719.32 -0.48201C1583.83 -0.48201 1473.77 99.3957 1473.77 222.501L1719.32 222.501V-0.48201Z",
    fill: "#76AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.723 445.342C341.723 322.382 231.668 222.504 96.019 222.504L96.019 445.342L341.723 445.342Z",
    fill: "#76AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620.63 266.069C1675.22 266.069 1719.48 306.236 1719.48 355.785C1719.48 405.333 1675.22 445.5 1620.63 445.5C1566.03 445.5 1521.77 405.333 1521.77 355.785C1521.77 306.236 1566.03 266.069 1620.63 266.069Z",
    fill: "#629EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.888 -0.470993C249.486 -0.470993 293.745 39.6961 293.745 89.2447C293.745 138.793 249.486 178.96 194.888 178.96C140.291 178.96 96.0308 138.793 96.0308 89.2447C96.0308 39.6961 140.291 -0.470993 194.888 -0.470993Z",
    fill: "#629EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1772.11 -2.81595V220.022L1894.81 220.022C1962.63 220.022 2017.5 170.083 2017.5 108.675C2017.5 47.2681 1962.47 -2.67085 1894.81 -2.67085L1772.11 -2.67085V-2.81595Z",
    fill: "#629EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.457 -0.327881L356.913 -0.327881L356.913 111.018C356.913 172.571 411.94 222.365 479.605 222.365C547.269 222.365 602.297 172.426 602.297 111.018V-0.327881H602.457Z",
    fill: "#629EFF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4253_21416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1854.02,
    height: 277,
    rx: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4253_21416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1950,
    height: 1768,
    fill: "white",
    transform: "translate(-48 -564)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgTop);
export default __webpack_public_path__ + "static/media/bg-top.0d4750f1ba35acfce74068fc6d5c6c41.svg";
export { ForwardRef as ReactComponent };